import { toast } from 'sonner';

export const ROLE_LABELS = {
  admin: 'Admin', principal: 'Principal', hr: 'HR', project_manager: 'Project Manager',
  design_lead: 'Design Lead', design: 'Design', construction: 'Construction',
};

export const DEPARTMENTS = ['Administration', 'Design', 'Construction', 'Finance', 'HR', 'Supply Chain'];

const legacyCopy = (text) => {
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.style.position = 'fixed';
  ta.style.opacity = '0';
  document.body.appendChild(ta);
  ta.select();
  const ok = document.execCommand('copy');
  document.body.removeChild(ta);
  return ok;
};

export const copyText = async (text, msg = 'Copied') => {
  try { await navigator.clipboard.writeText(text); toast.success(msg); }
  catch { legacyCopy(text) ? toast.success(msg) : toast.error('Copy failed'); }
};

export const credentialsText = (email, password) =>
  `Desq Employee Portal\nLogin: ${window.location.origin}/login\nEmail: ${email}\nTemporary password: ${password}\nYou will be asked to set a new password on first sign-in.`;

export const errMsg = (e, fallback) => {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map(x => x.msg).join(' ');
  return fallback;
};
